import React from 'react';
import TaskBarComponent from './TaskBarComponent';
import MeetingDetails from './MeetingDetails.js';

function CreateMeetings(){

    return (
        <div className="CreateMeetings">
            <TaskBarComponent/>
            <h3>Create Meetings</h3>
            <MeetingDetails />
        </div>
        
    );
} 
export default CreateMeetings;